import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useCallback, useEffect, useMemo, useState } from "react";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

export const useSuperpowers = () => {
  const dispatch = useDispatch();

  const freezeTimePowerUsed = useSelector(selectors.getFreezeTimePowerUsed);
  const fixTilePowerUsed = useSelector(selectors.getFixTilePowerUsed);
  const rotations = useSelector(selectors.getRotations);
  const status = useSelector(selectors.getGameStatus);

  const [freezeTimeTimerRef, setFreezeTimeTimerRef] = useState(null);

  const onFreezeTimePowerClicked = useCallback(() => {
    if (!freezeTimeTimerRef) {
      const powerTimer = setTimeout(() => {
        dispatch(actions.setIsTimerFrozen(false));
        clearTimeout(powerTimer);
        setFreezeTimeTimerRef(null);
        dispatch(actions.playSound("freezeResumeAudioId"));
      }, 5000);

      setFreezeTimeTimerRef(powerTimer);
    }

    dispatch(actions.setIsTimerFrozen(true));
    dispatch(actions.setFreezeTimePowerUsed(true));
    dispatch(actions.playSound("freezeAudioId"));
  }, [dispatch, freezeTimeTimerRef]);

  const onFixTilePowerClicked = useCallback(() => {
    const tilesWithIndexes = rotations.map((rotation, index) => ({
      ...rotation,
      index,
    }));
    const wrongTiles = tilesWithIndexes.filter(
      (rotation) => rotation.turns % 4 !== 0,
    );

    const randomTileIndex = Math.floor(Math.random() * wrongTiles.length);
    const randomWrongTile = wrongTiles[randomTileIndex];

    let turnsToBeFixed = randomWrongTile.turns;

    while (turnsToBeFixed % 4 !== 0) {
      turnsToBeFixed += 1;
    }

    dispatch(
      actions.fixTile({
        tileIndex: randomWrongTile.index,
        turns: turnsToBeFixed,
      }),
    );
    dispatch(actions.setFixTilePowerUsed(true));
    dispatch(actions.playSound("fermatesseraAudioId"));
  }, [dispatch, rotations]);

  const isFreezeTimePowerDisabled = useMemo(
    () => status !== GameStatus.PLAYING || freezeTimePowerUsed,
    [status, freezeTimePowerUsed],
  );
  const isFixTilePowerDisabled = useMemo(
    () => status !== GameStatus.PLAYING || fixTilePowerUsed,
    [status, fixTilePowerUsed],
  );

  useEffect(
    () => () => {
      if (freezeTimeTimerRef) {
        clearTimeout(freezeTimeTimerRef);
      }
    },
    [freezeTimeTimerRef],
  );

  return {
    onFixTilePowerClicked,
    onFreezeTimePowerClicked,
    freezeTimePowerUsed,
    isFreezeTimePowerDisabled,
    isFixTilePowerDisabled,
  };
};
